import logo from "./logo.svg";
import "./App.css";
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
//import useScript from "./useScript";

//web
import WebCatalog from "./components/Web/Catalog";
//import CatalogViewer from "./components/Web/CatalogViewer";

//cms
import Signin from "./components/Cms/Signin/Signin";
import Profile from "./components/Cms/Profile/Profile";
import AccountTable from "./components/Cms/Account/AccountTable";
import AccountEdit from "./components/Cms/Account/AccountEdit";
import CatalogTable from "./components/Cms/Catalog/CatalogTable";
import CatalogEdit from "./components/Cms/Catalog/CatalogEdit";
import HotspotEditorPage from "./components/Cms/Catalog/HotspotEditorPage";

function App() {
  //console.log(process.env.NODE_ENV);
  //const token = sessionStorage.getItem('accessToken');

  /*useScript(
    "/PDFFlip/bigC-test.js"
  )*/

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<WebCatalog />} />

        <Route path="/catalog/:pdfFile" element={<WebCatalog />} />
        <Route
          path="/e582c4f1-1c3e-4104-8189-198dfbd4694d/:pdfFile"
          element={<WebCatalog />}
        />
        <Route path="/cmsAdmin" element={<Signin />} />
        <Route path="/cms-profile" element={<Profile />} />
        <Route path="/cms-account" element={<AccountTable />} />
        <Route path="/cms-account/add" element={<AccountEdit />} />
        <Route path="/cms-account/edit/:id" element={<AccountEdit />} />
        <Route path="/cms-catalogs" element={<CatalogTable />} />
        <Route path="/cms-catalogs/add" element={<CatalogEdit />} />
        <Route path="/cms-catalogs/edit/:id" element={<CatalogEdit />} />
        <Route
          path="/cms-catalogs/hotspot/:catalogId"
          element={<HotspotEditorPage />}
        />

        {/*<Route path="/new-catalog/:pdfFile" element={<CatalogViewer />} />*/}

        <Route path="*" element={<WebCatalog />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
